import { ITokenData } from '../../rest/oauth';
import { getTokenName } from './get-token-name';

export const getTokenFromStorage = (): ITokenData | null => {
  const tokenName = getTokenName();
  const tokenData = localStorage.getItem(tokenName);

  if (tokenData) {
    return JSON.parse(tokenData);
  }

  return null;
};
